// How one field of a ticket's diagnostic context is rendered.
//
// Extracted because of a real failure, 2026-08-22: the panel rendered every field with `String(v)`,
// which is correct for the flat context it was written for (url, route, user_agent, build...) and
// silently wrong the moment a structured field arrived. A submitted call trace — the whole point of
// attaching one — displayed as the literal text "[object Object]" to the only person who could act
// on it.
//
// `String()` never fails and never warns. That is exactly why this is a function with tests rather
// than an expression inline in JSX.

/** Does this value need printing rather than coercing? */
export function isStructured(v) {
  return v !== null && typeof v === 'object';
}

/**
 * The text to show for a context field.
 *
 * Objects and arrays are printed as JSON. Everything else is coerced, including `null` and
 * `undefined`, which are worth SEEING in triage — a field present but empty is a different fact
 * from a field absent, and both are things the submitter's browser actually reported.
 */
export function formatContextValue(v) {
  if (isStructured(v)) {
    try {
      return JSON.stringify(v, null, 1);
    } catch {
      // A cycle cannot reach here through D1 (the context arrives as parsed JSON), but a renderer
      // that throws takes the whole triage page down with it, so it degrades instead.
      return '[unprintable object]';
    }
  }
  return String(v);
}
